export const SUCCESS = "submission/SUCCESS";



// WEBPACK FOOTER //
// ./app/lib/submission/constants.js